export const authConfig = {
  provider: process.env.REACT_APP_AUTH_PROVIDER,
  domain: process.env.REACT_APP_DOMAIN,
  clientId: process.env.REACT_APP_CLIENTID,
  audience: process.env.REACT_APP_AUDIENCE,
  keycloak: {
    url: process.env.REACT_APP_KEYCLOAK_URL,
    realm: process.env.REACT_APP_KEYCLOAK_REALM,
    // Accept both spellings: REACT_APP_KEYCLOAK_CLIENT_ID (Keycloak docs style)
    // or REACT_APP_KEYCLOAK_CLIENTID (matches existing Auth0 REACT_APP_CLIENTID).
    clientId:
      process.env.REACT_APP_KEYCLOAK_CLIENT_ID ||
      process.env.REACT_APP_KEYCLOAK_CLIENTID,
  },
};
